import {TActiveItem} from 'modules/bottom-bar/types';

export const BOTTOM_BAR_BUTTONS: {[key: string]: TActiveItem} = {
    CART: 'cart',
    CATALOG: 'catalog',
    FAVORITE: 'favorite',
    MAIN: 'main',
    PROFILE: 'profile',
    SALE: 'sale',
    WINE_SHOPS: 'wineShops',
};
